<script setup lang="ts">
import {
  TransitionRoot,
  TransitionChild,
  Dialog,
  DialogPanel,
  DialogTitle,
} from "@headlessui/vue";
import { disclaimerTypes } from "@/enums/disclaimerTypes";

interface Props {
  message: string;
  isOpen: boolean;
  close: () => void;
  type?: disclaimerTypes;
}

const props = withDefaults(defineProps<Props>(), {
  isOpen: false,
  close: () => {},
  type: disclaimerTypes.WARNING,
});

let style = {
  iconName: "",
  iconStyle: "",
  buttonStyle: "",
};

switch (props.type) {
  case disclaimerTypes.WARNING:
    style.iconName = "warning";
    style.iconStyle = "text-yellow-400";
    style.buttonStyle =
      "bg-yellow-200 text-yellow-900 hover:bg-yellow-500 focus-visible:ring-yellow-400";
    break;
  case disclaimerTypes.INFO:
    style.iconName = "info";
    style.iconStyle = "text-blue-400";
    style.buttonStyle =
      "bg-blue-200 text-blue-900 hover:bg-blue-500 focus-visible:ring-blue-400";
    break;
  case disclaimerTypes.ERROR:
    style.iconName = "error";
    style.iconStyle = "text-red-400";
    style.buttonStyle =
      "bg-red-200 text-red-900 hover:bg-red-500 focus-visible:ring-red-400";
    break;
}
</script>

<template>
  <TransitionRoot appear :show="isOpen" as="template">
    <Dialog as="div" class="relative z-50" @close="close">
      <TransitionChild
        as="template"
        enter="duration-300 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-200 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-black bg-opacity-25" />
      </TransitionChild>

      <div class="fixed inset-0 overflow-y-auto">
        <div
          class="flex min-h-full items-center justify-center p-4 text-center"
        >
          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95"
          >
            <DialogPanel
              class="w-full max-w-md transform select-none overflow-hidden rounded-xl bg-gray-50 p-6 text-right align-middle text-gray-900 shadow-xl transition-all"
            >
              <DialogTitle
                as="h3"
                class="flex items-center gap-2 text-xl font-semibold leading-6"
              >
                <span :class="['material-symbols-outlined', style.iconStyle]">
                  {{ style.iconName }}
                </span>
                Aviso
              </DialogTitle>
              <div class="mt-4">
                <p class="text-justify text-sm">{{ message }}</p>
              </div>

              <div class="mt-2">
                <button
                  type="button"
                  :class="[
                    'ml-auto inline-flex justify-center rounded-md border border-transparent  px-4 py-2 text-sm font-bold focus:outline-none focus-visible:ring-2 fade-transition hover:text-white  focus-visible:ring-offset-2',
                    style.buttonStyle,
                  ]"
                  @click="close"
                >
                  Entendido
                </button>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>
